module.exports = __webpack_public_path__ + "bc7ace6e50c7d9d4d95923b61b1de59c.woff2";